// src/pages/PaymentMethodsPage.jsx
import SearchableSelect from '../../components/ui/SearchableSelect';
import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { 
  Card, 
  CardContent, 
  Button, 
  Dialog, 
  DialogContent, 
  Typography, 
  Box, 
  Grid, 
  TextField,
  MenuItem,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container // <--- هذا هو الاستيراد الذي كان مفقوداً
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Save as SaveIcon } from '@mui/icons-material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export default function PaymentMethodsPage() {
  const companyId = parseInt(localStorage.getItem('companyId'), 10);
  const [methods, setMethods] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  
  const [form, setForm] = useState({
    id: null, 
    code: '', 
    nameAr: '', 
    nameEn: '', 
    paymentType: 1, 
    accountId: ''
  });

  useEffect(() => {
    fetchMethods();
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const res = await axios.get(`/ChartOfAccounts/postable`);
      setAccounts(res.data || []);
    } catch (err) { console.error(err); }
  };

  const fetchMethods = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`/PaymentMethod/by-company/${companyId}`);
      setMethods(res.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { 
        ...form, 
        companyId, 
        isActive: true,
        paymentType: parseInt(form.paymentType),
        accountId: form.accountId || null
    };

    try {
      if (form.id) {
        await axios.put(`/PaymentMethod/${form.id}`, payload);
      } else {
        await axios.post('/PaymentMethod', payload);
      }
      
      setSuccessModal(true);
      setTimeout(() => setSuccessModal(false), 2000);
      setForm({ id: null, code: '', nameAr: '', nameEn: '', paymentType: 1, accountId: '' });
      fetchMethods();
    } catch (err) {
      alert('حدث خطأ أثناء الحفظ');
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل أنت متأكد من حذف طريقة الدفع هذه؟')) return;
    try {
      await axios.delete(`/PaymentMethod/${id}`);
      fetchMethods();
    } catch (err) {
      alert('حدث خطأ أثناء الحذف');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, pb: 4 }} dir="rtl">
      <Card sx={{ p: 3, borderRadius: '24px' }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" mb={4}>📋 إدارة طرق الدفع</Typography>
          
          <form onSubmit={handleSubmit} className="mb-8">
            <Grid container spacing={3}>
              <Grid item xs={12} md={2}>
                <TextField fullWidth label="الرمز" name="code" value={form.code} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField fullWidth label="الاسم بالعربي" name="nameAr" value={form.nameAr} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField fullWidth label="الاسم بالإنجليزية" name="nameEn" value={form.nameEn} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField fullWidth select label="النوع" name="paymentType" value={form.paymentType} onChange={handleChange}>
                  <MenuItem value={1}>نقدي</MenuItem>
                  <MenuItem value={2}>تحويل بنكي</MenuItem>
                  <MenuItem value={3}>شبكة/بطاقة</MenuItem>
                  <MenuItem value={4}>آجل</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField fullWidth select label="الحساب المحاسبي" name="accountId" value={form.accountId} onChange={handleChange}>
                  <MenuItem value="">-- اختر --</MenuItem>
                  {accounts.map(acc => <MenuItem key={acc.id} value={acc.id}>{acc.code} - {acc.nameAr}</MenuItem>)}
                </TextField>
              </Grid>
            </Grid>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button type="submit" variant="contained" size="large" startIcon={<SaveIcon />}>
                {form.id ? 'تحديث البيانات' : 'إضافة طريقة دفع'}
              </Button>
            </Box>
          </form>

          <TableContainer component={Paper} elevation={0} variant="outlined">
            <Table>
              <TableHead sx={{ bgcolor: '#f9fafb' }}>
                <TableRow>
                  <TableCell align="center">الرمز</TableCell>
                  <TableCell>الاسم</TableCell>
                  <TableCell align="center">النوع</TableCell>
                  <TableCell align="center">الحساب المرتبط</TableCell>
                  <TableCell align="center">إجراءات</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {methods.map(m => (
                  <TableRow key={m.id}>
                    <TableCell align="center">{m.code}</TableCell>
                    <TableCell>{m.nameAr}</TableCell>
                    <TableCell align="center">{m.paymentType}</TableCell>
                    <TableCell align="center">{accounts.find(a => a.id === m.accountId)?.nameAr || '-'}</TableCell>
                    <TableCell align="center">
                      <IconButton onClick={() => setForm(m)} color="primary"><EditIcon /></IconButton>
                      <IconButton onClick={() => handleDelete(m.id)} color="error"><DeleteIcon /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      <Dialog open={successModal} PaperProps={{ sx: { borderRadius: '24px', p: 3, textAlign: 'center' } }}>
        <DialogContent>
          <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
          <Typography variant="h6" fontWeight="bold">تم الحفظ بنجاح</Typography>
        </DialogContent>
      </Dialog>
    </Container>
  );
  
}